<ng-container *ngIf="!isLoading else loading">
	<div class="password-wraper">
		<div class="wrapper">
			<div class="header1">
				<div class="logo"></div>
				<div class="login-nav-menu">
					<ul>
						<li>
							<span>
								<img [src]="'/assets/img/legacy/flag_' + lang + '.gif'" width="20" height="13" (click)="langsDisplayed = !langsDisplayed" alt="en">
							</span>
							&ngsp;
							<br>
							<span class="login-langues left1000 langs5"
								*ngIf="langsDisplayed"
								(mouseout)="outDivLangs()"
								(mouseover)="inDivLangs()"
								(focus)="inDivLangs()"
								(blur)="outDivLangs()"
								tabindex="0"
								@appearAnimation
								>
								<a (click)="setLanguage('de')"><img src="/assets/img/legacy/flag_de.gif" width="20" height="13" alt="de"></a>
								<a (click)="setLanguage('en')"><img src="/assets/img/legacy/flag_en.gif" width="20" height="13" alt="en"></a>
								<a (click)="setLanguage('es')"><img src="/assets/img/legacy/flag_es.gif" width="20" height="13" alt="es"></a>
								<a (click)="setLanguage('fr')"><img src="/assets/img/legacy/flag_fr.gif" width="20" height="13" alt="fr"></a>
								<a (click)="setLanguage('it')"><img src="/assets/img/legacy/flag_it.gif" width="20" height="13" alt="it"></a>
								<a (click)="setLanguage('pl')"><img src="/assets/img/legacy/flag_pl.gif" width="20" height="13" alt="pl"></a>
							</span>
						</li>
						<li>
							<div class="login-contact-us" translate>
								<a><span translate>login-legacy.contact-us</span></a>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<div class="header2">
			<div class="table bandeau_login">
				<div class="table-row">
					<div class="table-cell logo_steeluser"></div>
					<div class="table-cell pl58 w200"></div>
					<div class="table-cell parent-not-referenced"></div>
					<div class="table-cell border-login"></div>
				</div>
			</div>
		</div>
		<div class="middle copo-legacy-black">
			<div class="table w100p">
				<div class="table-row">
					<div class="table-cell w50p pl15 pr15 pb20 pt20">
						<div class="pb20">
							<form [formGroup]="confirmPasswordFormGroup" (ngSubmit)="onSubmit()" novalidate autocomplete="off">
								<div class="block-title h30">
									<span class="title-left" translate>confirm-password-legacy.stu-welcome</span>
								</div>
								<div class="block-content pb20 pt20">
									<div class="table collapse w100p pr15">
										<div class="table-row">
											<div class="table-cell">
												<div class="pl15 pb20 help-text">
													<span translate>confirm-password-legacy.choose-new-password</span>
												</div>
												<div class="pl15 pr15">
													<div class="block-title h30">
														<span class="title-left" translate>confirm-password-legacy.user-information</span>
													</div>
													<div class="block-content pb20 pt20">
														<div class="table w100p">
															<div class="table-row">
																<div class="table-cell">
																	<div class="table collapse w100p">
																		<div class="table-row">
																			<div class="table-cell w25p align-right valign-cell pt5">
																				<span translate>confirm-password-legacy.firstname</span>&ngsp;:
																			</div>
																			<div class="table-cell w75p pr15 pl15 pt5">
																				<span class="borderbox inlineblock">
																					<input formControlName="firstName" type="text" size="20" class="copo-legacy-width-314" autocomplete="given-name">
																				</span>
																			</div>
																		</div>
																		<div class="table-row">
																			<div class="table-cell w25p align-right valign-cell pt5">
																				<span translate>confirm-password-legacy.lastname</span>&ngsp;:
																			</div>
																			<div class="table-cell w75p pr15 pl15 pt5">
																				<span class="borderbox inlineblock">
																					<input formControlName="lastName" type="text" size="20" class="copo-legacy-width-314" autocomplete="family-name">
																				</span>
																			</div>
																		</div>
																		<div class="table-row">
																			<div class="table-cell w25p align-right valign-cell pt5">
																				<span translate>confirm-password-legacy.gender</span>&ngsp;:
																			</div>
																			<div class="table-cell w75p pr15 pl15 pt5">
																				<span class="borderbox inlineblock">
																					<select formControlName="gender" class="copo-legacy-width-314" autocomplete="honorific-prefix">
																						<option *ngFor="let gender of genders" [value]="gender.value">
																							{{ gender.display | translate }}
																						</option>
																					</select>
																				</span>
																			</div>
																		</div>
																		<div class="table-row">
																			<div class="table-cell w25p align-right valign-cell pt5">
																				<span translate>confirm-password-legacy.language</span>&ngsp;:
																			</div>
																			<div class="table-cell w75p pr15 pl15 pt5">
																				<span class="borderbox inlineblock">
																					<select formControlName="language" class="copo-legacy-width-314" autocomplete="language">
																						<option *ngFor="let language of languages" [value]="language.value">
																							{{ language.display | translate }}
																						</option>
																					</select>
																				</span>
																			</div>
																		</div>
																		<div class="table-row">
																			<div class="table-cell w25p align-right valign-cell pt5">
																				<span translate>login-legacy.email-address</span>&ngsp;:
																			</div>
																			<div class="table-cell w75p pr15 pl15 pt5">
																				<span class="borderbox inlineblock">
																					<input formControlName="email" type="text" size="20" class="copo-legacy-width-314" autocomplete="email">
																				</span>
																			</div>
																		</div>
																	</div>
																</div>

																<div class="table-cell pt20">
																	<div class="table collapse w100p">
																		<div class="table-row">
																			<div class="table-cell w25p align-right valign-cell pt5">
																				<span translate>confirm-password-legacy.login</span>&ngsp;:
																			</div>
																			<div class="table-cell w75p pr15 pl15 pt5">
																				<span class="borderbox inlineblock">
																					<input formControlName="username" type="text" size="20" class="copo-legacy-width-314" autocomplete="username">
																				</span>
																			</div>
																		</div>
																		<div class="table-row">
																			<div class="table-cell w25p align-right valign-cell pt5">
																				<span translate>login-legacy.password</span>&ngsp;:
																			</div>
																			<div class="table-cell w75p pr15 pl15 pt5">
																				<span class="borderbox inlineblock">
																					<input formControlName="password" type="password" size="20" class="copo-legacy-width-314" autocomplete="new-password" [pattern]="passwordPatternStr">
																					<div><mat-error *ngIf="submitted && password && password.errors && (password.errors['required'] || password.errors['pattern'])" translate>confirm-password-legacy.password-not-respect-rules</mat-error></div>
																				</span>
																			</div>
																		</div>
																		<div class="table-row">
																			<div class="table-cell w25p align-right valign-cell pt5">
																				<span translate>confirm-password-legacy.confirm-password</span>&ngsp;:
																			</div>
																			<div class="table-cell w75p pr15 pl15 pt5">
																				<span class="borderbox inlineblock">
																					<input type="password" formControlName="confirmPassword" size="20" class="copo-legacy-width-314" autocomplete="new-password" [pattern]="passwordPatternStr">
																				</span>
																				<div><mat-error *ngIf="submitted && confirmPassword && confirmPassword.errors && (confirmPassword.errors['required'] || confirmPassword.errors['pattern'])" translate>confirm-password-legacy.password-not-respect-rules</mat-error></div>
																				<div><mat-error *ngIf="submitted && confirmPasswordFormGroup.hasError('noMatching')" translate>confirm-password-legacy.bad-confirm-password</mat-error></div>
																			</div>
																		</div>
																		<div class="table-row">
																			<div class="table-cell w25p align-right valign-cell pt5">
																			</div>
																			<div class="table-cell w75p valign-cell pt5">
																				<h4><span translate>confirm-password-legacy.checklist-title</span></h4>
																				<div>
																					<p [ngClass]="password && password.errors && (password.errors['required'] || password.errors['patternLowerCase']) ? 'invalid' : 'valid'"><span translate>confirm-password-legacy.lowercase-check</span></p>
																					<p [ngClass]="password && password.errors && (password.errors['required'] || password.errors['patternUpperCase']) ? 'invalid' : 'valid'"><span translate>confirm-password-legacy.uppercase-check</span></p>
																					<p [ngClass]="password && password.errors && (password.errors['required'] || password.errors['patternDigit']) ? 'invalid' : 'valid'"><span translate>confirm-password-legacy.number-check</span></p>
																					<p [ngClass]="password && password.errors && (password.errors['required'] || password.errors['patternSpecialChars']) ? 'invalid' : 'valid'"><span translate>confirm-password-legacy.specialchar-check</span></p>
																					<p [ngClass]="password && password.errors && (password.errors['required'] || password.errors['minlength']) ? 'invalid' : 'valid'"><span translate>confirm-password-legacy.length-check</span></p>
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div class="table-row">
											<div class="table-cell">
												<div class="right pt20 pr15 pl15">
													<button color="accent" class="submit-button" type="submit" [disabled]="submitting">
														<span class="copo-legacy-nowrap" *ngIf="!submitting; else submittingMessage" translate>confirm-password-legacy.confirm</span>
														<ng-template #submittingMessage><span translate>login.loading</span></ng-template>
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div id="login-footer" class="login-footer password-footer">
		© ArcelorMittal {{ year }}
		&ndash;&ngsp;<a (click)="openPrivacyPolicyDialog()" translate>login-legacy.privacy-policy</a>
		&ndash;&ngsp;<a (click)="openFaqDialog()" translate>login-legacy.faq</a>
		<div class="middle_corner"></div>
	</div>
</ng-container>
<ng-template #loading>
	<copo-loading-spinner></copo-loading-spinner>
</ng-template>